import React from 'react';

import { Label } from '@atlas/ui';

const HeaderInfoUnauthorizedSignupPage = () => {
  return (
    <div className="header-info__btn">
      <a className="header__signin btn secondary medium block" href="?cmd=signin">
        <Label message="login" />
      </a>
    </div>
  );
};

export default HeaderInfoUnauthorizedSignupPage;
